import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import apiUrl from '../config/http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: sessionStorage.getItem('token') || '',
    user: {},
    isAdmin: false,
    statusImage: '',
    users: [],
    filter: '',
    globalLoading: false,
    loading:null,
    totalUsers: 0,
    documentType: [],
    modalPrivacy: false
  },
  mutations: {
    openModalPrivacy() {

    },
    setDocumentType(state, value) {
      state.documentType = value
    },
    setGlobalLoading(state, value){
      state.globalLoading = value
    },
    setFilter(state, value) {
      state.filter = value
    },
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, token) {
      state.status = 'success'
      state.token = token
      
    },
    auth_error(state) {
      state.status = 'error'
    },
    auth_admin(state) {
      state.isAdmin = true
    },
    logout(state) {
      state.status = '',
      state.token = ''
    },
    set_user(state, user) {
      state.user = user
    },
    setAdminUsers(state, users) {
      state.users = users
    },
    statusUploadRegImage(state) {
      state.statusImage = 'success'
    },
    statusUploadRegImageError(state) {
      state.statusImage = 'error'
    },
    loading(state, value) {
      state.loading = value
    },
    setTotalUsers(state, total) {
      state.totalUsers = total
    }
  },
  actions: {
    changeType({commit}, data) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios({url: `${apiUrl}/admin/api/user/set/type`, data: data, method: 'POST'})
            .then(res => {
              commit('loading', false)
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
      })
    },

    login({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: `${apiUrl}/api/login`, data: user, method: 'POST'})
        .then(res => {
          const token = res.data.access_token
          const user = res.data.user
          sessionStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          commit('auth_success', token)
          resolve(res)
        })
        .catch(err => {
          commit('auth_error')
          sessionStorage.removeItem('token')
          reject(err)
        })
      })
    },
    register({commit}, {user}) {
  
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: `${apiUrl}/api/signup`, data: user, method: 'POST'})
        .then(res => {
          const token = res.data.access_token
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          resolve(res)
        })
        .catch(err => {
          commit('auth_error')
          sessionStorage.removeItem('token')
          reject(err)
        })
      })
    },
    loginAdmin({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')     
        axios({url: `${apiUrl}/admin/api/login`, data: user, method: 'POST'})
        .then(res => {
          const token = res.data.access_token        
          sessionStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          commit('auth_success', token)
          commit('auth_admin')
          resolve(res)
        })
        .catch(err => {
          commit('auth_error')
          sessionStorage.removeItem('token')       
          reject(err)
        })
      })
    },
    logout({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout')
        sessionStorage.removeItem('token')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    getUser({commit}) {
      return new Promise((resolve, reject) => {    
        axios({url: `${apiUrl}/api/user`})
        .then(res => {       
          const user = res.data
          commit('set_user', user)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    getUsersAdmin({commit}, {offset, limit, value}) { 
      return new Promise((resolve, reject) => {
        commit('loading', true)
        if(!value) {
          axios({url: `${apiUrl}/admin/api/users?limit=${limit}&offset=${offset}`})
          .then(res => {
          
            const users = res.data.users
            const size = res.data.size
            commit('setAdminUsers', users)
            commit('setTotalUsers', size)
            commit('loading', false)
            resolve(res)
          })
          .catch(err => {      
            reject(err)
          })
        }else {
          axios({url: `${apiUrl}/admin/api/users?limit=${limit}&offset=${offset}&search=${value}`})
          .then(res => {                   
            const users = res.data.users
            const size = res.data.size
            commit('setAdminUsers', users)
            commit('setTotalUsers', size)
            commit('loading', false)
            resolve(res)
          })
          .catch(err => {   
            reject(err)
          })
        }

      })
    },
    aproveUser({commit}, user) {
      commit("loading", true)
      return new Promise((resolve, reject) => {
        axios({url: `${apiUrl}/admin/api/user/verify`, data:user, method: 'POST'})
        .then(res => {
          commit("loading", false)
          resolve(res)
        })
        .catch(err => {
          commit("loading", false)
          reject(err)
        }) 
      })
    },
    upload({commit}, {form}) {
      return new Promise((resolve, reject) => {
        axios({url:`${apiUrl}/api/upload`, data: form, method: 'POST', 
          headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
        .then(res => {
          if (res.data.automatic_verification.image_quality == 'Good' || res.data.automatic_verification.verification_passed) {
            commit('statusUploadRegImage')
          } else {
            commit('statusUploadRegImageError')
          }

          resolve(res)
        })
        .catch(err => {
          commit('statusUploadRegImageError')
          reject(err)
        })
      })
    },
    getUserById({commit}, id) {
      return new Promise((resolve, reject) => {
        axios({url: `${apiUrl}/admin/api/user/${id}`})
        .then((res) => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    approveUser({commit}, id){
      return new Promise((resolve,reject) => {
        axios({url: `${apiUrl}/admin/api/user/verify`, data: id, method: "POST"})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    updateUser({commit}, {form}) {
      return new Promise((resolve, reject) => {
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        axios({url: `${apiUrl}/api/user`, data: form, method:"PUT"})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    sendEmailToSupport({commit}, params) {
      return new Promise((resolve, reject) => {
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        axios({url: `${apiUrl}/api/support`, data: params, method:"POST"})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    sendTransactionId({commit}, params) {
      return new Promise((resolve, reject) => {
        const token = sessionStorage.getItem('token');
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios({url: `${apiUrl}/api/swaps`, data: params, method:"POST"})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    getDocType({commit}) {
      return new Promise((resolve, reject) => {
        axios({url: `${apiUrl}/api/doctypes`})
        .then(res => {
          commit('setDocumentType', res.data)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    changeBalance({commit}, data) {
      return new Promise((resolve, reject) => {
        axios({url: `${apiUrl}/admin/api/update_balance`, data, method: "POST"})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    deleteUser({commit}, data) {
      return new Promise((resolve, reject) => {
        axios({url: `${apiUrl}/admin/api/user/${data}`, method: "DELETE"})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        }) 
      })
    },
    sendCoin({commit}, data) {
      return new Promise((resolve, reject) => {
        axios({url: `${apiUrl}/admin/api/user/send`, data, method: "POST"})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        }) 
      })
    },
    editWallet({commit}, data) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios({url: `${apiUrl}/admin/api/user/update/wallet`, data, method: "POST"})
            .then(res => {
              commit('loading', false)
              resolve(res);
            })
            .catch(err => {
              commit('loading', false)
              reject(err);
            })
      })
    }
  },
  getters: {
    isLogin: state => !!state.token,
    authStatus: state => state.status,
    getUser: state => state.user,
    getAdminUsers: state => state.users,
    loading: state => state.loading,
    getTotalUsers: state => state.totalUsers,
    getGlobalLoading: state => state.globalLoading,
    getDocumentType: state => state.documentType,
    getStatusUploadPicture: state => state.statusImage
  },
})
